import React from 'react';
import './App.css'; // Importer votre fichier CSS pour la stylisation

function App() {
  return (
    <div className="container">
      <header>
        <h1>Politique de confidentialité de l'application Mirage</h1>
        <p><strong>Dernière mise à jour :</strong> 31 mars 2024</p>
      </header>
      <main>
        <section>
          <h2>Collecte et utilisation des informations</h2>
          <p>Nous ne collectons aucune information personnelle identifiable auprès des utilisateurs de notre application Mirage.</p>
        </section>
        <section>
          <h2>Partage des informations</h2>
          <p>Nous ne partageons aucune information personnelle identifiable des utilisateurs de notre application Mirage avec des tiers.</p>
        </section>
        <section>
          <h2>Cookies et technologies similaires</h2>
          <p>Notre application Mirage n'utilise pas de cookies ni de technologies similaires pour collecter des informations sur les utilisateurs.</p>
        </section>
        <section>
          <h2>Sécurité des données</h2>
          <p>La sécurité des données des utilisateurs est importante pour nous, mais rappelez-vous qu'aucune méthode de transmission sur Internet ou méthode de stockage électronique n'est sécurisée à 100%. Bien que nous nous efforcions d'utiliser des moyens commercialement acceptables pour protéger les informations personnelles des utilisateurs, nous ne pouvons garantir leur sécurité absolue.</p>
        </section>
        <section>
          <h2>Modifications de la politique de confidentialité</h2>
          <p>Cette politique de confidentialité peut être mise à jour de temps à autre pour refléter les changements dans nos pratiques en matière d'information. Nous vous encourageons à consulter cette page périodiquement pour toute modification. La dernière mise à jour a été effectuée le 31 mars 2024.</p>
        </section>
        <section>
          <h2>Contactez-nous</h2>
          <p>Si vous avez des questions ou des préoccupations concernant notre politique de confidentialité, veuillez nous contacter via mon profil LinkedIn: Thibaut de Lignerolles</p>
        </section>
      </main>
    </div>
  );
}

export default App;
